export const legalRoutes = {
  privacyPolicy: '/privacy-policy',
  termsConditions: '/term-conditions',
  minorConsentForm: '/minor-consent-form',
} as const;

export const legalAssets = {
  privacyPolicyHtml: '/privacy_policy_healthkit.html',
  termsConditionsPdf: '/terms_conditions.pdf',
  minorConsentFormPdf: '/minor_consent_form.pdf',
} as const;
